import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.fit()
    this.resizeObserver = new ResizeObserver(() => {
      cancelAnimationFrame(this.frameId)
      this.frameId = requestAnimationFrame(() => this.fit())
    })
    this.resizeObserver.observe(this.element.parentElement)
  }

  disconnect() {
    cancelAnimationFrame(this.frameId)
    this.resizeObserver?.disconnect()
  }

  fit() {
    const parent = this.element.parentElement
    if (!parent) return

    const containerWidth = parent.clientWidth
    // Start large and binary search down to the right size
    let low = 1
    let high = containerWidth
    this.element.style.whiteSpace = "nowrap"
    this.element.style.display = "inline-block"

    while (low < high) {
      const mid = Math.ceil((low + high) / 2)
      this.element.style.fontSize = `${mid}px`
      if (this.element.scrollWidth <= containerWidth) {
        low = mid
      } else {
        high = mid - 1
      }
    }

    this.element.style.fontSize = `${low}px`
    this.element.style.whiteSpace = ""
    this.element.style.display = ""
  }
}
